"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const motion = {
    "duration50": "0.05s",
    "duration100": "0.1s",
    "duration150": "0.15s",
    "duration200": "0.2s",
    "duration250": "0.25s",
    "duration300": "0.3s",
    "duration350": "0.35s",
    "duration400": "0.4s",
    "duration500": "0.5s",
    "duration1500": "1.5s",
    "duration2000": "2s",
    "easeIn": "cubic-bezier(0.35, 0.07, 0.88, 0.43)",
    "easeOut": "cubic-bezier(0.33, 0.9, 0.75, 0.95)",
    "easeInOut": "cubic-bezier(0.45, 0, 0.52, 0.98)"
};
exports.default = motion;
